export enum APP_ROUTES {
  Login = '/',
  SignIn = '/email-signin',
  SignInEmail = '/email-signin',
  SignInCode = '/email-signin/code',
  SignInCheckEmail = '/email-signin/check_email',
  ErrorVPN = '/error-vpn',
  ErrorBanned = '/error-banned',
  UserInfo = '/user-info',
  UserInfoLite = '/user-info-lite',
  PayWallMob = '/pay-wall-standalone',
  Checkout = '/checkout',
  TermsOfService = '/terms',
  PrivacyPolicy = '/privacy',
  CookiePolicy = '/cookie-policy',
  CommunityGuidelines = '/community-guidelines',
  AmbassadorAgreement = '/ambassador-public-agreement',
  Home = '/app/profile',
  FAQ = '/app/faq',
  Map = '/app/map',
  Chats = '/app/chats',
  Chat = '/app/chat',
  People = '/app',
  LikedPeople = '/app/liked-people',
  Subscription = '/app/subscription',
  PhotoIssues = '/app/photo-issues',
  Verification = '/app/verification',
  Settings = '/app/settings',
  SearchSettings = '/app/search-settings',
  Location = '/app/search-settings/location',
  Account = '/app/account',
  DeleteAccount = '/app/account-delete',
  SocialMedia = '/app/social-media',
  EditProfile = '/app/edit-profile',
  EditInterests = '/app/edit-interests',
  EditLanguages = '/app/edit-languages',
  EditEthnicities = '/app/edit-ethnicities',
  EditNationalities = '/app/edit-nationalities',
  Translator = '/app/translator',
  TranslateChat = '/app/translate-chat',
  TranslationLanguage = '/app/translation-language',
  Report = '/app/report',
  UnconfirmedEmail = '/app/unconfirmed-email',
}
